var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodeSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7L17 10.5",
    stroke: "#ffffff",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13.5L10.5 17",
    stroke: "#ffffff",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7L7 10.5",
    stroke: "#ffffff",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 13.5L13.5 17",
    stroke: "#ffffff",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5.5,
    r: 2,
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18.5,
    r: 2,
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 12,
    r: 2,
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 12,
    r: 2,
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5.5,
    r: 0.5,
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18.5,
    r: 0.5,
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 12,
    r: 0.5,
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 12,
    r: 0.5,
    stroke: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeSvg);
export default __webpack_public_path__ + "static/media/NodeSVG.bfe186951b1addfc141e53639f175910.svg";
export { ForwardRef as ReactComponent };